import api from '../api';
const routes = require('routes.js.erb');

const getCurrentOrganization = function({ commit }, organizationId){
  return api.get(routes.api_v5_organization_path(organizationId)).then(result => commit("setCurrentOrganization", result["data"]["data"]["organization"]));
}

const getOrganization = function({ commit }, organizationId) {
  return api.get(routes.api_v5_organization_path(organizationId))
}

const updateOrganizationBilling = function({ commit }, params){
  return api.put(routes.api_v5_organization_payment_methods_path(params.organizationId), { recurly_token: params.recurlyToken }).then(result => commit("setCurrentOrganization", result["data"]["data"]["organization"]));
}

const createMembership = function({ commit }, params) {
  return api.post(routes.create_autojoin_member_api_v5_organization_path(params.organizationId), { role: params.role } )
}

export { getCurrentOrganization, getOrganization, updateOrganizationBilling, createMembership };
